module.exports = __webpack_public_path__ + "img/PC3.30f1da47.png";